import { useRef, type ReactElement } from "react";
import { SearchShell, PhoneSearch, UserDetailCard } from "@citibox-panel/lockers-care";
import {
  searchUsersByPhoneMock,
  fetchUserDeviceMock,
  fetchUserDeliveriesMock,
  deleteUserMock,
  updateUserMock,
  blockUserMock,
  unblockUserMock,
  fetchLocationsMock,
} from "@citibox-panel/api-client";
import { Avatar } from "@citibox-panel/ui";

// Mounts the real phone search in the shell's search slot — the exact wiring
// HomeView uses, but against the deterministic mock so the catalog works
// offline. Type a phone (612 348 902 → 1 user, 678 221 540 → 2) and Enter;
// "+" / ⌘K / the empty-state action focus the input through onNewSearch. The
// demo shares the page's router, so PhoneSearch's openSearch persists tabs into
// the /ui-kit query string — doubling as a live demo of refresh-safe persistence.
//
// The ficha's edit mode is fed from the same mocks, and the showcase deliberately passes NEITHER
// `onRenamed` nor `onAnnounce`: there is no tab label to keep in step with a name here (this demo's
// tabs are the showcase's own) and no announcement region on the /ui-kit page. Both props are
// optional precisely so a second mount point can decline them — what it must not do is decline the
// two fetchers, which would leave the form unable to save and the address field perpetually in
// flight.
export function SearchShellDemo(): ReactElement {
  const searchInputRef = useRef<HTMLInputElement>(null);
  return (
    <SearchShell
      fillViewport={false}
      onNewSearch={() => {
        searchInputRef.current?.focus();
      }}
      headerEnd={<Avatar>MO</Avatar>}
      searchSlot={
        <PhoneSearch
          search={searchUsersByPhoneMock}
          inputRef={searchInputRef}
        />
      }
      renderUser={(search) => (
        <UserDetailCard
          search={search}
          searchUsers={searchUsersByPhoneMock}
          fetchDevice={fetchUserDeviceMock}
          fetchDeliveries={fetchUserDeliveriesMock}
          deleteUser={deleteUserMock}
          updateUser={updateUserMock}
          blockUser={blockUserMock}
          unblockUser={unblockUserMock}
          searchLocations={fetchLocationsMock}
        />
      )}
    />
  );
}
